import { gql } from "@apollo/client";

export default gql`
  mutation createCollageTemplateSet($input: CreateCollageTemplateSetInput!){
    createCollageTemplateSet(input: $input){
        success
        data{
            folder{
                _id
                customer
                parentFolder
                name
                visibleTo
                selectedCPersons
                createdAt
                updatedAt
            }
            templates{
                _id
                customer
                name
                isDefault
                frame
                collage
                header
                footer
                backgroundColor
                textColor
                mainColor
                secondaryColor
                priceTextColor
                discountLabel
                discountStyle
                footerFontWeight
                footerPriceSizeDelta
                footerCodeSizeDelta
                mainLogo{
                    name
                    type
                    path
                }
                secondaryLogo{
                    name
                    type
                    path
                }
                coverImage{
                    name
                    type
                    path
                }
                productDataSource
                visibleTo
                selectedCPersons
                createdAt
                updatedAt
            }
        }
        code
        message
    }
}
`
